<!-- 学校-教师考勤统计 -->
<template>
  <div>
    <div class="index" v-show="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{$route.name}}</span>
        </div>
        <p style="color:#606266;font-size:14px;">截止日期:{{dayjs().format('YYYY-MM-DD')}}</p>
      </div>

      <!-- <header>
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>教师考勤率前五名</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>教师考勤率后五名</span>
          </div>
          <div id="echarts-box2"></div>
        </div>
      </header> -->

      <div>
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
              <el-select
                v-model="queryParams.semester"
                placeholder="请选择学年学期"
              >
                <el-option
                  v-for="item in semesterList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="">
            <el-input v-model="queryParams.name" placeholder="请输入教师姓名"></el-input>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>

        <!-- 机构教师 -->
        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="teacherName" label="教师姓名" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="extOrgName" label="所属单位" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="courseNum" label="授课课程数" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="classNum" label="课时总数" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="needAttendanceNum" label="应出勤次数" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="attendanceNum" label="实际出勤次数" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="attendanceRate" label="出勤率" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column header-align="center" align="center" label="操作" width="200">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Detail
      :info="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
      :semester="detail_semester"
      :semesterList="semesterList"
    ></Detail>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import _ from "lodash";
import dayjs from "dayjs";
import * as echarts from "echarts";
export default {
  components: {
    Detail: () => import("./detail.vue"),
  },
  data() {
    return {
      tabName: "校内教师",
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        semester: "",
        name: "",
      },
      tabList: [{ name: "校内教师" }, { name: "机构教师" }],
      semesterList: [],
      tableData: [],
      detail: {
        info: {},
        show: false,
      },
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      detail_semester:'',
    };
  },
  watch: {

  },
  created() {},
  methods: {
    dayjs,
    async getDataList() {
      let params = {
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        schoolYearSemester: this.queryParams.semester,
        teacherName: this.queryParams.name,
        page: this.pageNum,
        limit: this.pageSize,
      };
      let res = await api.teacherAttendance(params);
      if (res.code === "0") {
        this.tableData = res.data?.list || [];
        this.totalPage = res.data?.total || 0;
        this.detail_semester = this.queryParams.semester;
      }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    init(){
      let vm = this;
      this.$nextTick(() => {
        // 柱状图
        let chartDom1 = document.getElementById('echarts-box1');
        let myChart1 = echarts.init(chartDom1);
        let option1 = {

          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['李必先\n本校', '陈正清\n本校', '林佩玲\n海鸟信息', '吴俊伯\n第七感官', '邓诗晗\n邓诗晗'],
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [100.00, 100.00, 100.00, 97.87, 97.87],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: '#5BB0FF' },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                  label: {
                    formatter: "{c}%",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
                
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart1.setOption(option1);

        // 柱状图
        let chartDom2 = document.getElementById('echarts-box2');
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: 'category',
            data: ['何正义\n本校', '钟卫华\n智课', '林华新\n本校', '舒本义\n第七感官', '刘兰贵\n本校'],
            axisLine: {
              //坐标线
              lineStyle: {
                type: 'solid',
                color: '#DDDDDD', //轴线的颜色
                width: '1', //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: '#999999', //坐标值的具体的颜色
              },
            },
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: [64, 63, 60, 59, 42],
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: 'none', //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: '#51D6A6' },
                  ]),
                  label: {
                    formatter: "{c}%",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999"
                    }
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);
      });
    },
  },
  mounted() {
    if(this.semesterArr && this.semesterArr.length>0){
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "年度" + (v.semester === 1 ? "上学期" : "下学期"),
        value: v.schoolYear + "_" + v.semester,
        id: v.id,
        isCurrent: v.isCurrent,
      }));
      this.queryParams.semester = this.semesterList.filter(e=>e.isCurrent)[0]?.value;
    }
    this.getDataList();
    // this.init();
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }

    header{
    width: 100%;
    height: 350px;
    display: flex;
    .header-item{
      width: 50%;
      .header-item-title{
        font-size: 18px;
        color: #333;
        display: flex;
        align-items: center;
        .circle{
          width: 8px;
          height: 8px;
          display: inline-block;
          background: #4991e1;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
      .header-item-text{
        font-size: 14px;
        color: #666;
        padding-left: 20px;
        margin-top: 5px;
      }
    }
    #echarts-box1, #echarts-box2{
      width:90%;
      height:280px;
    }
  }
}
</style>
